import { notification } from "~/components/ui";
import { useTranslation } from "react-i18next";

export const useNotImplementedYet = () => {
  const { t } = useTranslation();

  const showNotImplementedYet = (icon?: React.ReactNode) =>
    notification.open({
      message: t("common:notImplemented.title"),
      description: t("common:notImplemented.description"),
      icon,
    });

  return showNotImplementedYet;
};
